(() => {
  const root = document.querySelector('[data-rsp-faq]');
  if (!root) return;
  const input = root.querySelector('[data-rsp-faq-search]');
  const items = [...root.querySelectorAll('[data-rsp-faq-item]')];
  const groups = [...root.querySelectorAll('[data-rsp-faq-group]')];
  const count = root.querySelector('[data-rsp-faq-count]');
  const empty = root.querySelector('[data-rsp-faq-empty]');

  const filter = () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;
    items.forEach((item) => {
      const matches = !query || `${item.textContent} ${item.dataset.rspFaqTerms || ''}`.toLowerCase().includes(query);
      item.hidden = !matches;
      item.open = Boolean(query && matches);
      if (matches) visible += 1;
    });
    groups.forEach((group) => { group.hidden = ![...group.querySelectorAll('[data-rsp-faq-item]')].some((item) => !item.hidden); });
    count.textContent = query ? `${visible} ${visible === 1 ? 'answer' : 'answers'} found` : 'Showing all answers';
    empty.hidden = visible !== 0;
  };

  input.addEventListener('input', filter);
  root.querySelector('[data-rsp-faq-clear]')?.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
})();
